import { render } from "./StudentWithTrainingsBar.vue?vue&type=template&id=4ba560bc&scoped=true"
import script from "./StudentWithTrainingsBar.vue?vue&type=script&lang=js"
export * from "./StudentWithTrainingsBar.vue?vue&type=script&lang=js"

import "./StudentWithTrainingsBar.vue?vue&type=style&index=0&id=4ba560bc&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/standart-system-front-student/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ba560bc"]])

export default __exports__